import { Component, Input, Output, EventEmitter, HostListener, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';

@Component({
    moduleId: String(module.id),
    selector: 'kui-header',
    templateUrl: './header.component.html',
})
export class KuiHeaderComponent implements AfterViewInit {
    body: HTMLElement = document.body;
    height: number;

    @Input() colorScheme = 'light';
    @Input() background = 'faded';
    @Input() asMain: boolean;
    @Input() position: 'relative' | 'absolute' | 'fixed' = 'relative';
    @Input() placeholder = true;

    @Output() onHeightChange = new EventEmitter<number>();

    @ViewChild('header', { static: true }) private header: ElementRef;
    @HostListener('window:resize') resize() { this.setHeight(); }

    constructor(private ref: ChangeDetectorRef) { }

    ngAfterViewInit() {
        this.setHeight();

        // solves this issue https://github.com/angular/angular/issues/6005#issuecomment-165905348
        this.ref.detectChanges();
    }

    setHeight() {
        if (!this.asMain && (this.position === 'fixed' || this.position === 'absolute')) {
            this.height = this.header.nativeElement.clientHeight;
            this.onHeightChange.emit(this.height);
        }
    }
}
